import React from "react";
import Loading from "../../assets/images/loading.svg";
import { motion } from "framer-motion";
import useWindowSize from "react-use/lib/useWindowSize";

const LoadingIndicator = () => {
  const { width, height } = useWindowSize();
  return (
    <div
      style={{ height, width }}
      className="flex items-center justify-center fixed top-0 left-0"
    >
      <motion.img
        style={{ maxWidth: 150 }}
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{
          type: "spring",
          stiffness: 100,
          repeat: Infinity,
          repeatDelay: 0.5
        }}
        src={Loading}
        alt="loading..."
      />
    </div>
  );
};

export default LoadingIndicator;
